<template>
  <div class="elite-content_sidebar_level2">
    <div class="elite-content_sidebar_level2_inner">
      <h2>{{ $t("APPS.ADMIN_MODULE") }}</h2>
      <ul class="sub-menu-items">
        <!-- <li v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_OPTIONS)">
          <router-link
            :to="{ name: 'List Options' }"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a
              :href="href"
              @click="navigate"
              :class="{ 'active-link': isActive }"
            >
              <span class="text">
                {{ $t("COMMON.OPTIONS") }}
              </span>
            </a>
          </router-link>
        </li> -->
        <li v-if="$currentUserIsLevelAdmin">
          <router-link
            :to="{ name: 'List Clients' }"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a
              :href="href"
              @click="navigate"
              :class="{ 'active-link': isActive }"
            >
              <span class="text">
                {{ $t("COMMON.CLIENTS") }}
              </span>
            </a>
          </router-link>
        </li>
        <li v-if="$currentUserIsLevelAdmin">
          <router-link
            :to="{ name: 'List Users' }"
            v-slot="{ href, navigate, isActive }"
            custom
          >
            <a
              :href="href"
              @click="navigate"
              :class="{ 'active-link': isActive }"
            >
              <span class="text">
                {{ $t("COMMON.USERS") }}
              </span>
            </a>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  mixins: [],

  data() {
    return {};
  },

  methods: {},

  async mounted() {},

  computed: {},

  watch: {},
};
</script>
